var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notification",class:{ 'is-success': _vm.isSuccess }},[_c('Sprite',{attrs:{"name":_vm.icon}}),_c('span',[_vm._v(_vm._s(_vm.content))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }